const request = {
    invalid_input: '入力が無効です。 {{details}}',
    general: 'リクエストエラーが発生しました。',
    range_not_satisfiable: '要求範囲が満たされません。',
};
export default Object.freeze(request);
